export default (emailAddress, callback) => {
  let error = null
  const emailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (emailAddress && !emailRegexp.test(emailAddress)) {
    error = `${emailAddress} is not a valid email address`
  }
  if (error && callback) callback(error)

  return error
}
